import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_down_black",
  "use": "arrow_down_black-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_down_black\">\n<path d=\"M8 10L12 14L16 10\" stroke=\"#424242\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol